<div class="h-70-px shadow-md w-full bg-white">
    <div class="flex items-center justify-between h-full px-8">
        <div class="flex items-center gap-2">
            <button class="material-icons mr-1 cursor-pointer" 
                *ngIf="showBackButton"
                (click)="onBackClick()" 
                aria-label="Back">arrow_back</button>

            <span class="font-semibold uppercase text-xs" *ngIf="!title_is_array">{{ navigation_title }}</span>
            <div class="grid grid-cols-4 gap-1" *ngIf="title_is_array">
                <div class="col-span-1" *ngFor="let item of navigation_title">
                    <a class="title uppercase cursor-pointer font-bold text-inherit no-underline" 
                        [routerLink]="item.route" 
                        [class.active-route]="isRouteActive(item.routeMatch ?? item.route)">
                        {{ item.title }}
                    </a>
                </div>
            </div>
            <!-- <div class="flex items-center">
                <span class="material-icons mr-3 cursor-pointer" *ngIf="title === 'dashboard'" (click)="refreshPage()">
                    refresh
                </span>
            </div> -->
        </div>

        <div class="flex items-center relative z-50">
            <button 
                *ngIf="showRefreshButton"
                class="material-icons mr-3 cursor-pointer" 
                (click)="onRefreshClick()" 
                aria-label="Refresh"
                matTooltip="Refresh"
                matTooltipPosition="left"
                matTooltipClass="custom-orange-tooltip">refresh
            </button>
        </div>
    </div>
</div>